import { utilityServiceUrl } from "../../../../libs/menu-shared/src/environments/default-menu.config";

const umbracoPage = (page: string) => {
  const umbracoUrl = page.startsWith('/') ? '' : '/';
  return `${umbracoUrl}${page}`;
}

export const environment = {
  production: false,
  LOCALES_BASEURL: '/content/dstv-streaming/i18n/locales/',
  APP_ROOT_URL: '/{culture}/dstv-stream',
  DEFAULT_LANGUAGE: 'en-za',
  DEFAULT_COUNTRY: 'za',
  BASEURL: '/{culture}/dstv-stream',
  SOURCE_FOLDER: '/content/dstv-streaming/',
  MAH_API_BASE_URL: 'https://qa-api.dstvafrica.com',
  MAH_API_VERSION: 'api/v1',
  MAH_API_CUSTOMER_PROFILE: 'customerprofilemanagement-unifiedapi',
  MAH_API_VOUCHER: 'vendorvouchermanagement-unifiedpso',
  MAH_API_CANCEL_PACKAGE: 'cancelpackage-unifiedapi',
  MAH_API_BUSINESS_UNIT: 'dstv',
  CONNECT_CLIENT_ID: 'da01a4c6-2d5e-4a30-84e0-31c555ed08b0',
  CONNECT_URL: 'https://alpha-authentication.dstv.com/registration',
  UMBRACO_CONNECT_URL: `${utilityServiceUrl}/connect`,
  UTILITY_API_URI: utilityServiceUrl,
  MAH_API_CHANNEL: 'webuni',
  PAY_AT_EXTERNAL_PAYMENT_LINK: 'https://payat.io/dstv',
  DEFAULT_CACHE_TIMEOUT: 1440,
  CACHE_TIMEOUT_PRODUCTS: 60,
  CACHE_TIMEOUT_ACCOUNT: 60,
  CACHE_TIMEOUT_CUSTOMER: 1440,
  CACHE_TIMEOUT_CONTENT: 1440,
  CACHE_TIMEOUT_CONFIG: 87600,
  CACHE_TIMEOUT_PAYMENTS: 1440,
  DEFAULT_CACHE_DEBOUNCE: 120,
  USE_CONNECT_JWT: true,
  USE_REFRESH_TOKEN: true,
  REFRESH_TOKEN_TOLERANCE: 5,
  DEFAULT_COUNTRY_NAME: 'South Africa',
  RESIDENTIAL_SELF_SERVICE: umbracoPage('/en-za/mydstv#'),
  BOXOFFICE: 'https://now.dstv.com',
  BUY_LANDING_PAGE: umbracoPage('/en-za/buy/dstv-packages/dstv-stream'),
  CAPITEC_LANDING_PAGE: umbracoPage('/en-za/dvs/capitec-landing-page'),
  FLEX_BUY_LANDING_PAGE: umbracoPage('/en-za/dvs/select-landing-page'),
  UMBRACO_BASE_URI: umbracoPage(''),
  ACCOUNT_TSANDCS_BANNER: 'https://multichoice.com/multichoice-africa-subscriber-ts-cs-overview-sa.php',
  ANALYTICS_STRUCTURE_API_URL: '',
  ANALYTICS_STRUCTURE_USE_API: 'true',
  USE_SEASON_PASS_API: 'true',
  HAPTIK_BASE_URL: 'https://staging.hellohaptik.com/',
  HAPTIK_CONCIERGE_BUSINESS_ID: '3378',
  HAPTIK_CONCIERGE_CLIENT_ID: 'cf822d2361e85797bd2c44ef752ccc5f4fa91640',
  HAPTIK_PRIVACY_POLICY_URL: 'https://www.multichoice.com/privacy-cookie-notice/',
  SHOW_HAPTIK_ON_BUYING_JOURNEY: false,
  PAYMENT_TYPES: ['CARD', 'CAPITEC_EFT', 'EFT', 'ONE_VOUCHER'],
  AIRTIME_PAYMENT_TYPES: [],
  FLEX_PACKAGES: 'FLEXDELENT,FLEXSELMOV,FLEXALLSP',
  STREAM_PACKAGES: 'PRMOTT,EXTRAKUOTT,ACCESSOTT',
  ANYWHERE_STREAMS_PACKAGES: 'PRMOTT,COMPKUOTT,EXTRAKUOTT',
  HARDCODED_ANYWHERE_STREAMS: true,
  DISABLE_SELECT: true,
  CAPITEC_DISCOUNT_RATE: 25,
  DVS_INCLUDE_PHONE_NUMBER: false,
  MAH_API_CAPITEC_BRANCH: 'ZA_DSTVSTRMCAPITEC',
  ENABLE_CONTRACT_PACKAGES: true,
  ENABLE_499_DEAL: false,
  SHOW_PRODUCT_TAGS: true,
  HIDE_MONTH_TO_MONTH_PAYMENTS: true,
  HIDE_MONTH_TO_MONTH_PRODUCT: '',
};
